export const defaultTransition = {
	type: 'spring' as const,
	bounce: 0,
};
